var map = {
	"./de.json": "./src/i18n/locales/de.json",
	"./en.json": "./src/i18n/locales/en.json",
	"./es.json": "./src/i18n/locales/es.json",
	"./fr.json": "./src/i18n/locales/fr.json",
	"./hi.json": "./src/i18n/locales/hi.json",
	"./it.json": "./src/i18n/locales/it.json",
	"./ja.json": "./src/i18n/locales/ja.json",
	"./pl.json": "./src/i18n/locales/pl.json",
	"./pt-BR.json": "./src/i18n/locales/pt-BR.json",
	"./pt.json": "./src/i18n/locales/pt.json",
	"./ru.json": "./src/i18n/locales/ru.json",
	"./uk-UA.json": "./src/i18n/locales/uk-UA.json",
	"./zh.json": "./src/i18n/locales/zh.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/i18n/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$/";